import UserList from "../components/UserList";

function UserListPage() {
  return <UserList />;
}

export default UserListPage;
